import React from 'react'
import IfRender from '@/components/IfRender'
import { provincesData, citysData, areasData } from './config'
import icClose from './icClose.png'
import icPitchOn from './icPitchOn.png'

import s from './index.module.css'
const navArr = ['province', 'city', 'area']


interface IProps {
  handleAddress: (address: { province: string, city: string, area: string }) => void
  closePicker: (flag: boolean) => void
  province?: string
  city?: string
  area?: string
}

const AddressPicker = ({
  handleAddress,
  closePicker,
  province = '请选择',
  city = '请选择',
  area = '请选择',
}: IProps) => {

  const [state, setState] = React.useState<{
    [key: string]: any
  }>({
    province: province,
    city: city,
    area: area,
    address: provincesData,
    cur: 'province',
  })


  const getAddressData = (type: string) => {
    const { province, city } = state
    switch (type) {
      case 'province':
        return provincesData
      case 'city':
        return citysData[province]
      case 'area':
        return areasData[city]
      default:
        return []
    }
  }

  // 切换省/市/区
  const handleSwitchAddress = (e: React.MouseEvent<HTMLElement>, type: string) => {
    e.stopPropagation();
    setState(pre => ({
      ...pre,
      address: getAddressData(type),
      cur: type,
    }))
  }

  const handleSelect = (item: string) => {
    const { cur } = state
    switch (cur) {
      case 'province':
        setState(pre => ({
          ...pre,
          area: '请选择',
          city: '请选择',
          province: item,
          cur: 'city', // 切换到市选择列表
          address: citysData[item],
        }))
        break;
      case 'city':
        setState(pre => ({
          ...pre,
          area: '请选择',
          city: item,
          cur: 'area', // 切换到区选择列表
          address: areasData[item],
        }))
        break;
      case 'area':
        setState(pre => ({
          ...pre,
          area: item,
        }))
        handleAddress({
          province: state.province,
          city: state.city,
          area: item
        })
        break;
      default:
        break;
    }
  }

  const renderContent = () => {
    const { address, cur } = state
    return (
      <div className={s.selectContent}>
        { address && address.map((item: string, index: number) =>
          <p
            onClick={() => handleSelect(item)}
            key={`picker${index}`}
          >
            {item}
            <IfRender show={state[cur] === item}>
              <img
                className={s.icPitchOn}
                src={icPitchOn}
                alt={''}
              />
            </IfRender>
          </p>)
        }
      </div>
    )
  }

  const renderPickerHead = () => {
    const { cur } = state
    return (
      <div className={s.selectHead}>
        {navArr.map((nav) => (
          <span
            key={nav}
            onClick={(e) => handleSwitchAddress(e, nav)}
            className={cur === nav ? s.active : ''}
          >
            {state[nav as 'province' | 'city' | 'area']}
          </span>
        ))}
      </div>
    )
  }

  const renderPicker = () => (
    <div className={s.picker}>
      <div className={s.head}>
          请选择区域
          <img
            className={s.icClose}
            src={icClose}
            alt={''}
            onClick={() => closePicker(false)}
          />
      </div>
      { renderPickerHead() }
      { renderContent() }
    </div>
    )

    return (
      <div className={s.container}>
        { renderPicker() }
      </div>
    )
}

export default AddressPicker
